import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { getStripePublishableKey } from '../../../../../../utils/payments';
import { DEFAULT_CURRENCY } from '../../../../../../utils/currency';
import RevolutStripeForm, { completePayment } from '../../../../../02_molecules/RevolutStripeForm';
import { RG, SD } from '../../../../../../utils/constants';
import unexpectedErrorMessage from '../../../../../../utils/unexpectedErrorMessage';
import { buildStepPath } from '../../../../../../utils/donationForm';
import {
  donationFormSubmitError,
  donationFormUnLock,
} from '../../../../../../store/Slices/cnet/donationFormSlice';

const stripePromise = loadStripe(getStripePublishableKey());

const DonationRevolutStripe = ({
  amount,
  orderID = null,
  donationType,
  dispatch = () => {},
  appealUrl = '',
  giftaid = false,
}) => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
  }, []);

  const checkoutUrl = buildStepPath(appealUrl, 'amount', { type: donationType });

  return (
    <>
      {visible && (
        <Elements
          stripe={stripePromise}
          // Math.round(amount * 100) is important here, since sometimes JS produces
          // odd results for multiplying, for example 2086.07 * 100 = 208607.00000000003.
          options={{
            mode: donationType === RG ? 'setup' : 'payment',
            currency: DEFAULT_CURRENCY.toLowerCase(),
            paymentMethodTypes: ['revolut_pay'],
            ...(donationType === SD ? { amount: Math.round(amount * 100) } : {}),
          }}
        >
          <RevolutStripeForm
            orderId={orderID}
            onCompletePayment={async (stripe, elements) => {
              const result = await completePayment(
                stripe,
                elements,
                orderID,
                donationType,
                checkoutUrl,
                giftaid,
                amount,
              );
              if (result.type === 'error') {
                // Show message to the user.
                dispatch(
                  donationFormSubmitError({
                    errorMessage: 'Sorry, we could not submit your donation.',
                    subline: unexpectedErrorMessage(),
                    additionalMessage: result.errorMessage,
                  }),
                );
              }
              dispatch(donationFormUnLock());
            }}
          />
        </Elements>
      )}
    </>
  );
};

DonationRevolutStripe.propTypes = {
  amount: PropTypes.number.isRequired,
  donationType: PropTypes.oneOf([SD, RG]).isRequired,
  appealUrl: PropTypes.string,
  orderID: PropTypes.number,
  dispatch: PropTypes.func,
  giftaid: PropTypes.bool,
};

const mapStateToProps = ({ donationForm: { form, orderID } }) => ({
  amount: +form.values.amount,
  orderID,
  donationType: form.values.type,
  appealUrl: form.values.appealUrl,
  giftaid: form.values.giftaid || false,
});

export default connect(mapStateToProps)(DonationRevolutStripe);
